<template>
  <div class="site-workflow-content">
    <el-row>
<!--
      <el-col :span="24">
        <edit-workflow
          :rowData="rowData"
          :site-id="rowData.site_id"
          :editatble="(rowData.percentComplete < 100)" />
      </el-col>
-->
      <el-col :span="24">
        <org-contact-assign :row-data="taskData" :row-index="rowIndex" />
      </el-col>

    </el-row>

        <el-card shadow="hover">

          <checklist-table
            :parent-data="rowData"
            :isSite="true"
            :percent-complete="rowData.percentComplete"
            :tableTitle="tableTitle"
          />

        </el-card>
  </div>
</template>



<script>

import WorkflowMixins from '@/mixins/WorkflowMixins'

import GoogleMap from '@/components/atoms/GoogleMap'

import OrgContactAssign from '@/components/workflow/site/OrgContactAssign'

import ChecklistTable from '@/components/workflow/checklist/ChecklistTable'

import EditWorkflow from '@/components/workflow/EditWorkflow'

export default {
  name: 'workflow-sites-details',

  mixins: [WorkflowMixins],

  components: {
    ChecklistTable,
    EditWorkflow,
    GoogleMap,
    OrgContactAssign
  },


  props: {
    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number
    }

  },



  data () {
    return {
      tableTitle: 'Site Checklist',
      taskData: this.rowData
    }
  }
}
</script>

<style scoped>

.site-workflow-content {
  border-radius: 1em;
  background-color: #D9ECFF; /* #F4F4F5; */
  margin-left: 34px;
  padding: 1.3em;
}

</style>
